import { SelectInput, SelectInputProps, useTranslate } from 'react-admin';
import { InputLabel } from '@mui/material';

export const GraySelectInputWithUpperLabel = (props: SelectInputProps) => {

  const translate = useTranslate();

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label">
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <SelectInput
        {...props}
        className={props.className ? `${props.className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        InputProps={{ ...props.InputProps, notched: false }}
        sx={{
          mt: 0,
          mb: 0,
          ...props.sx,
          '& .MuiOutlinedInput-root': {
            boxSizing: 'border-box',
            minHeight: 40,
            height: 40,
            alignItems: 'center',
          },
        }}
      />
    </>
  );

};
